import { Router } from 'express';
import { db } from '../storage';
import { User } from '../../src/types';

export const adminRouter = Router();

// Middleware-like check: can be expanded with tokens
// GET /api/admin/overview - Complete system statistics for Admin Master
adminRouter.get('/overview', (req, res) => {
  const stats = db.getAdminOverviewStats();
  res.json(stats);
});

// GET /api/admin/teachers - List all teachers with their metrics
adminRouter.get('/teachers', (req, res) => {
  const stats = db.getAdminOverviewStats();
  res.json(stats.teachers);
});

// POST /api/admin/teachers - Master admin creates a new client teacher account
adminRouter.post('/teachers', (req, res) => {
  const {
    name,
    email,
    password,
    phone,
    subject,
    role,
    googleSheetUrl,
    zaloPhone,
    subscriptionPlan,
    subscriptionStatus,
    subscriptionExpiresAt,
    defaultRatePerSession,
    maxClasses,
    adminNotes
  } = req.body;

  if (!name || !email) {
    return res.status(400).json({ error: 'Tên giáo viên và Email là bắt buộc' });
  }

  const existing = db.getUserByEmail(email);
  if (existing) {
    return res.status(400).json({ error: 'Email này đã tồn tại trong hệ thống.' });
  }

  let googleSheetId = '';
  if (googleSheetUrl && googleSheetUrl.includes('/d/')) {
    const match = googleSheetUrl.match(/\/d\/([a-zA-Z0-9-_]+)/);
    if (match) googleSheetId = match[1];
  }

  const newTeacher: User = {
    id: `teacher_${Date.now()}`,
    name,
    email,
    password: password || '123456',
    phone: phone || '',
    role: role || 'teacher',
    subject: subject || 'Giáo viên tự do',
    avatarUrl: `https://api.dicebear.com/7.x/bottts/svg?seed=${encodeURIComponent(name)}`,
    googleSheetUrl: googleSheetUrl || '',
    googleSheetId,
    googleAppsScriptUrl: '',
    zaloPhone: zaloPhone || phone || '',
    themePreference: 'sophisticated_dark',
    salaryCalculationType: 'per_session',
    defaultRatePerSession: defaultRatePerSession ? Number(defaultRatePerSession) : 350000,
    defaultRevenueSharePercent: 100,
    subscriptionStatus: subscriptionStatus || 'active',
    subscriptionPlan: subscriptionPlan || 'pro',
    subscriptionExpiresAt: subscriptionExpiresAt || '2027-12-31',
    activatedAt: new Date().toISOString(),
    maxClasses: maxClasses ? Number(maxClasses) : 10,
    adminNotes: adminNotes || '',
    createdAt: new Date().toISOString(),
  };

  db.createUser(newTeacher);
  res.json({ teacher: newTeacher });
});

// PUT /api/admin/teachers/:id - Master admin updates client teacher license/info
adminRouter.put('/teachers/:id', (req, res) => {
  const { id } = req.params;
  const updates = req.body;

  if (updates.googleSheetUrl && updates.googleSheetUrl.includes('/d/')) {
    const match = updates.googleSheetUrl.match(/\/d\/([a-zA-Z0-9-_]+)/);
    if (match) updates.googleSheetId = match[1];
  }

  const updated = db.updateUser(id, updates);
  if (!updated) {
    return res.status(404).json({ error: 'Không tìm thấy giáo viên' });
  }

  res.json({ teacher: updated });
});

// DELETE /api/admin/teachers/:id - Master admin deletes teacher and all their data
adminRouter.delete('/teachers/:id', (req, res) => {
  const { id } = req.params;
  const targetUser = db.getUserById(id);
  if (id === 'admin_master' || targetUser?.role === 'admin') {
    return res.status(400).json({ error: 'Không thể xóa tài khoản Quản trị viên Master' });
  }

  const success = db.deleteUser(id);
  res.json({ success });
});

// POST /api/admin/teachers/:id/extend-subscription - Master admin quickly extends subscription
adminRouter.post('/teachers/:id/extend-subscription', (req, res) => {
  const { id } = req.params;
  const { months, days, customExpiryDate, planName, status } = req.body;

  const teacher = db.getUserById(id);
  if (!teacher) {
    return res.status(404).json({ error: 'Không tìm thấy giáo viên' });
  }

  let newExpiry: Date;
  if (customExpiryDate) {
    newExpiry = new Date(customExpiryDate);
  } else {
    const currentExpiry = teacher.subscriptionExpiresAt ? new Date(teacher.subscriptionExpiresAt) : new Date();
    const baseDate = currentExpiry > new Date() ? currentExpiry : new Date();

    if (months) {
      baseDate.setMonth(baseDate.getMonth() + Number(months));
    } else if (days) {
      baseDate.setDate(baseDate.getDate() + Number(days));
    } else {
      baseDate.setMonth(baseDate.getMonth() + 1); // default +1 month
    }
    newExpiry = baseDate;
  }

  const updated = db.updateUser(id, {
    subscriptionStatus: status || 'active',
    subscriptionPlan: planName || teacher.subscriptionPlan || 'Gói Gia Hạn Admin',
    subscriptionExpiresAt: newExpiry.toISOString()
  });

  res.json({
    success: true,
    message: `Đã gia hạn thành công tài khoản đến ngày ${newExpiry.toLocaleDateString('vi-VN')}`,
    teacher: updated
  });
});

// GET /api/admin/system-settings - Get system branding configuration
adminRouter.get('/system-settings', (req, res) => {
  const settings = db.getSystemSettings();
  res.json(settings);
});

// PUT /api/admin/system-settings - Update system branding configuration
adminRouter.put('/system-settings', (req, res) => {
  const updates = req.body;
  const updated = db.updateSystemSettings(updates);
  res.json(updated);
});

adminRouter.post('/system-settings', (req, res) => {
  const updates = req.body;
  const updated = db.updateSystemSettings(updates);
  res.json(updated);
});
